import './brokerCryptoFrame.scss'

// @vendors
const { formatText } = require('core/i18n').i18n;
// @components
import { OKCover } from 'commonsComponents/OKCover';
import { OKBreadcrumb } from 'commonsComponents/OKBreadcrumb';
// @constants
import { MYPROFILE_BROKER_CRYPTO_URL } from 'constants/index';
import { CRYPTO_TEST_STATES, CRYPTO_TEST_STATUS } from 'mifid/constants/constants'
// @types
import PropTypes from 'prop-types';

const { TEST_IN_PROGRESS } = CRYPTO_TEST_STATES;
const { IN_PROGRESS } = CRYPTO_TEST_STATUS;

export default function BrokerCryptoFrame({children, immBrokerConvenienceMiFIDTest, title}) {
    const mappingBreadcrumb=[
        {
            text: formatText('brokerCryptoTest-breadcrumb_firstLabel'),
            url: MYPROFILE_BROKER_CRYPTO_URL,
        },
        {
            text: formatText('brokerCryptoTest-breadcrumb_secondLabel'),
            url: ''
        },
    ];
    const immTest = immBrokerConvenienceMiFIDTest.get("test");
    const isEditing = immBrokerConvenienceMiFIDTest.getIn(["test", "isEditing"], false);
    const testState = immTest.get('cryptoTestState');
    const testStatus = immTest.get('testStatus');
    const testCounterEnabled = testState === TEST_IN_PROGRESS && testStatus === IN_PROGRESS;
    const currentQuestionIndex = immTest.get('cryptoTestIndex');
    const cryptoTestLength = immTest.get('cryptoTestLength');
    const counterText = isEditing
        ? formatText('brokerCryptoTest-frameSubtitle_edit')
        : formatText('brokerCryptoTest-frameSubtitle_steps', [currentQuestionIndex+1, cryptoTestLength]);
    const testStepCounter = testCounterEnabled
        ? (
            <div className='broker-crypto-frame__cover-test-counter'>
                {counterText}
            </div>
        )
        : null;

    const coverTitleContainerStyle = {
        marginTop: testCounterEnabled ? '20px' : '40px'
    };

    return (
        <div>
            <div>
                <OKCover
                    size='large'
                    extraClass='crypto-test-cover'
                >
                    <div className='broker-crypto-frame__cover-breadcrumb'>
                        <OKBreadcrumb mapping={mappingBreadcrumb}/>
                    </div>
                    <div className='broker-crypto-frame__cover-title-container' style={coverTitleContainerStyle}>
                        <h1 className='broker-crypto-frame__cover-title' >
                            {title}
                        </h1>
                        {testStepCounter}
                    </div>
                </OKCover>
            </div>
            <div className="broker-crypto-frame__background">
                <div className="broker-crypto-frame__box">{children}</div>
            </div>
        </div>
    )
}

BrokerCryptoFrame.propTypes = {
    children: PropTypes.node.isRequired,
    title: PropTypes.string.isRequired,
    immBrokerConvenienceMiFIDTest: PropTypes.object.isRequired
};
